"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i18n = require("@ms/yammer-i18n");
const usesWrappers={};
exports.default = i18n.getStringInterpolator(usesWrappers, 'skiplink');
